export default __webpack_public_path__ + "static/media/1004.6913c4ce.png";